const doc = [({"TextFilter":({"PlaceHolder":"À la recherche de députés ..."}), "Buttons":({"Close":"Fermer"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;